import React from "react";

export default function BillNumber(props) {
  const { billNumber } = props;
  return <p class="bill-number">{billNumber}</p>;
}
